import API from './api';

export default class Page extends API {
  constructor(config = {}) {
    config.path = 'v1/pages';

    super(config);
  }

  metrics(pageIdentifier, params = {}) {
    return this.get(`${pageIdentifier}/metrics`, params);
  }

  emails(pageIdentifier, params = {}) {
    return this.get(`${pageIdentifier}/emails`, params);
  }

  exportEmails(pageIdentifier, params = {}) {
    return this.get(`${pageIdentifier}/emails/export`, params);
  }

  chartData(pageIdentifier, params = {}) {
    return this.get(`${pageIdentifier}/metrics/charts`, params);
  }

  locations(pageIdentifier, params = {}) {
    return this.get(`${pageIdentifier}/metrics/locations`, params);
  }

  locationCoordinates(pageIdentifier, params = {}) {
    return this.get(`${pageIdentifier}/metrics/locations/coordinates`, params);
  }
}



// WEBPACK FOOTER //
// ./src/services/request/page.js